import { defineMessages } from 'react-intl';

export const scope = 'app.component.base.button';

export default defineMessages({
  button: {
    id: `${scope}.button`,
    defaultMessage: 'Button',
  },
});
